export default "__VITE_ASSET__e2c281b9__"